<div class="row content" *appRole="['Propiedades.Ver']">
  <div class="col-sm-2">
    <app-nav-panel-propiedad [idPropiedad]="idPropiedad"></app-nav-panel-propiedad>
  </div>

  <div class="col-sm-10 position-relative">
    <ngx-spinner [zIndex]="100" name="spVerPropiedad" bdColor="rgba(255,255,255,0.8)" size="default" color="#009688"
      type="ball-atom" [fullScreen]="false"></ngx-spinner>

    <app-sin-datos *ngIf="fallo"
      icono="error_outline"
      mensaje="No se pudo cargar la propiedad"
      detalle="Volvé al listado y probá de nuevo.">
    </app-sin-datos>

    <div *ngIf="!fallo && propiedadDto">

      <!-- Acciones arriba, como en el contrato -->
      <div class="acciones-propiedad">
        <button mat-raised-button color="primary" *appRole="['Propiedades.Modificar']" (click)="editar()">
          <mat-icon>edit</mat-icon>
          Editar
        </button>
        <button mat-button color="warn" (click)="volver()">Volver</button>
      </div>

      <mat-tab-group animationDuration="0ms">

        <!-- ============================ PROPIEDAD ============================ -->
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon class="example-tab-icon">roofing</mat-icon>&nbsp; Propiedad
          </ng-template>

          <ng-template matTabContent>
            <div class="container-mat-card">

              <div class="row">
                <div class="col-6">
                  <mat-card>
                    <mat-card-header>
                      <mat-card-title>Información Propiedad</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>

                      <div class="row">
                        <div class="col-6">
                          <mat-label><b>Estado: </b></mat-label>
                          <span>{{ isFalsy(propiedadDto.estadoPropiedad) ? "" : propiedadDto.estadoPropiedad?.descripcion | titlecase }}</span>
                        </div>
                        <div class="col-6">
                          <mat-label><b>Fecha alta: </b></mat-label>
                          <span>{{ propiedadDto.fechaAlta | date:'dd/MM/yyyy' }}</span>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-6">
                          <mat-label><b>Tipo: </b></mat-label>
                          <span>{{ isFalsy(propiedadDto.tipoPropiedad) ? "" : propiedadDto.tipoPropiedad?.descripcion | titlecase }}</span>
                        </div>
                        <div class="col-6">
                          <mat-label><b>Subtipo: </b></mat-label>
                          <span>{{ isFalsy(propiedadDto.subtipoPropiedad) ? "" : propiedadDto.subtipoPropiedad?.descripcion | titlecase }}</span>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-6">
                          <mat-label><b>Clase: </b></mat-label>
                          <span>{{ isFalsy(propiedadDto.propiedadClase) ? "" : propiedadDto.propiedadClase?.descripcion | titlecase }}</span>
                        </div>
                        <div class="col-6">
                          <mat-label><b>Localidad: </b></mat-label>
                          <span>{{ localidad | titlecase }}</span>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12">
                          <mat-label><b>Ubicación: </b></mat-label>
                          <span>{{ direccion | titlecase }}</span>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-6">
                          <mat-label><b>Código CPA: </b></mat-label>
                          <span>{{ propiedadDto.codigoCpa }}</span>
                        </div>
                        <div class="col-6">
                          <mat-label><b>Antigüedad: </b></mat-label>
                          <span>{{ propiedadDto.antiguedad }}</span>
                        </div>
                      </div>

                    </mat-card-content>
                  </mat-card>
                </div>

                <div class="col-6">
                  <mat-card>
                    <mat-card-header>
                      <mat-card-title>Medidas y valor</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>

                      <div class="row">
                        <div class="col-6">
                          <mat-label><b>Superficie total: </b></mat-label>
                          <span *ngIf="!isFalsy(propiedadDto.superficieTotal)">{{ propiedadDto.superficieTotal }} m²</span>
                        </div>
                        <div class="col-6">
                          <mat-label><b>Superficie cubierta: </b></mat-label>
                          <span *ngIf="!isFalsy(propiedadDto.superficieCubierta)">{{ propiedadDto.superficieCubierta }} m²</span>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-6">
                          <mat-label><b>Precio: </b></mat-label>
                          <span *ngIf="!isFalsy(propiedadDto.precio)">{{ propiedadDto.precio | currency:'USD':'symbol':'1.2-2' }}</span>
                        </div>
                        <div class="col-6">
                          <mat-label><b>Horizontal: </b></mat-label>
                          <span>{{ propiedadDto.horizontal ? 'Sí' : 'No' }}</span>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-12">
                          <mat-label><b>Avisa por mail al emitir recibo: </b></mat-label>
                          <span>{{ propiedadDto.notificarRecibo ? 'Sí' : 'No' }}</span>
                        </div>
                      </div>

                    </mat-card-content>
                  </mat-card>
                </div>
              </div>

              <div class="row">
                <div class="col-6">
                  <mat-card>
                    <mat-card-header>
                      <mat-card-title>Datos registrales</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>

                      <div class="row">
                        <div class="col-6">
                          <mat-label><b>Tipo de folio: </b></mat-label>
                          <span>{{ isFalsy(propiedadDto.tipoFolio) ? "" : propiedadDto.tipoFolio?.descripcion }}</span>
                        </div>
                        <!-- El folio sólo aplica a los tipos que lo usan -->
                        <div class="col-6" *ngIf="muestraDatosRegistrales">
                          <mat-label><b>Nro. de folio: </b></mat-label>
                          <span>{{ propiedadDto.numeroFolio }}</span>
                        </div>
                      </div>

                      <div class="row" *ngIf="propiedadDto.tipoFolio?.id === 1">
                        <div class="col-6">
                          <mat-label><b>Tomo: </b></mat-label>
                          <span>{{ propiedadDto.tomo }}</span>
                        </div>
                        <div class="col-6">
                          <mat-label><b>Número: </b></mat-label>
                          <span>{{ propiedadDto.numero }}</span>
                        </div>
                      </div>

                    </mat-card-content>
                  </mat-card>
                </div>

                <div class="col-6" *ngIf="propiedadDto.observacion">
                  <mat-card>
                    <mat-card-header>
                      <mat-card-title>Observaciones</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                      <span class="observacion">{{ propiedadDto.observacion }}</span>
                    </mat-card-content>
                  </mat-card>
                </div>
              </div>

            </div>
          </ng-template>
        </mat-tab>

        <!-- =========================== PROPIETARIOS =========================== -->
        <mat-tab *appRole="['Propietarios.Ver']">
          <ng-template mat-tab-label>
            <mat-icon class="example-tab-icon">apartment</mat-icon>&nbsp; Propietarios
          </ng-template>

          <ng-template matTabContent>
            <div class="container-mat-card">
              <app-add-propietario-propiedades></app-add-propietario-propiedades>
            </div>
          </ng-template>
        </mat-tab>

        <!-- ========================== CARACTERÍSTICAS ========================== -->
        <mat-tab *appRole="['CaracteristicaPropiedad.Ver']">
          <ng-template mat-tab-label>
            <mat-icon class="example-tab-icon">deck</mat-icon>&nbsp; Características
          </ng-template>

          <ng-template matTabContent>
            <div class="container-mat-card">
              <app-caracteristica-propiedad></app-caracteristica-propiedad>
            </div>
          </ng-template>
        </mat-tab>

        <!-- ============================= AUDITORÍA ============================= -->
        <mat-tab *appRole="['Auditoria.Ver']">
          <ng-template mat-tab-label>
            <mat-icon class="example-tab-icon">history</mat-icon>&nbsp; Auditoría
          </ng-template>

          <ng-template matTabContent>
            <div class="container-mat-card">
              <!-- Sin el botón de historial: se sacó de la UI a pedido -->
              <app-info-auditoria *ngIf="idPropiedad > 0" entidad="Propiedades" [id]="idPropiedad"
                [mostrarHistorial]="false">
              </app-info-auditoria>
            </div>
          </ng-template>
        </mat-tab>

      </mat-tab-group>
    </div>
  </div>
</div>
